import { FluidStateStrategy } from '@lmig/fluid-core';

export class FluidBrowserStorage {
  static set(
    key: string,
    value: any,
    strategy: FluidStateStrategy = FluidStateStrategy.LOCAL
  ) {
    FluidBrowserStorage.storage(strategy).setItem(key, JSON.stringify(value));
  }

  static get<T>(
    key: string,
    strategy: FluidStateStrategy = FluidStateStrategy.LOCAL
  ): T {
    return JSON.parse(FluidBrowserStorage.storage(strategy).getItem(key)) as T;
  }

  static clear(
    key: string,
    strategy: FluidStateStrategy = FluidStateStrategy.LOCAL
  ): void {
    FluidBrowserStorage.storage(strategy).removeItem(key);
  }

  static storage(strategy: FluidStateStrategy = FluidStateStrategy.LOCAL) {
    return strategy === FluidStateStrategy.LOCAL
      ? localStorage
      : sessionStorage;
  }
}
